module.exports = require('./input.vue')



// WEBPACK FOOTER //
// ./src/index.js